{
  "month": {
    "2025-07": "July was a returning-shows month, led by crime and drama: Dexter: Resurrection topped the field at 9, with The Sandman adding a darker fantasy thread. It’s Always Sunny in Philadelphia brought a sharp comedy counterpoint, while AppleTV+ returns Acapulco and Foundation helped round out a schedule built more on familiar worlds than fresh starts.",
    "2025-08": "August gave returning shows and new arrivals room to land, with drama, comedy, and thriller all in the mix. Peacemaker led the returning lineup at 8.3, while Netflix’s Wednesday and Fisk kept its returning-show run strong. Newcomers Bon Appétit, Your Majesty and The Terminal List: Dark Wolf added Korean drama and action-thriller to the month.",
    "2025-09": "September balanced familiar favorites with fresh starts, led by returning comedies and dramas. Bob's Burgers S16 topped the month at 8.2, while Only Murders in the Building S5 and The Morning Show S4 kept the returning lineup strong. Prime Video newcomer The Runarounds and Netflix debuts You and Everything Else and Haunted Hotel gave viewers new stories to try.",
    "2025-10": "October had room for both returning favorites and fresh starts, with drama, comedy, and crime sharing the schedule. Hulu’s anime run led the returning shows: One Punch Man, My Hero Academia, and SPY x FAMILY all landed among the month’s strongest. Newcomers IT: Welcome to Derry and Netflix’s Boots added a darker, more grounded counterpoint.",
    "2025-11": "November leaned on new arrivals, with drama, crime and comedy running through a schedule led by Netflix, Prime Video and TF1. Prime Video had the month’s highest-rated show in The Family Man S3, while its newcomer The Mighty Nein also made a strong debut at 8.6. Delhi Crime S3 kept Netflix’s crime thread going, giving fresh starts and returning favorites room to share the month.",
    "2025-12": "December’s schedule leaned toward new arrivals, with drama, action, and fantasy setting the tone across Netflix, Prime Video, and BBC Two. Netflix brought a strong run of fresh titles, including The Abandons and The Price of Confession, while returning shows supplied the month’s highest ratings: Prime Video’s Fallout led at 8.3, followed by BBC Two’s Ghost Stories for Christmas.",
    "2026-01": "January balanced returning favorites with a steady run of new dramas, while crime and mystery threaded through the schedule. The Pitt led the month at 8.7 on MAX, with Shrinking and Call the Midwife also giving returning shows a strong showing. New arrivals like 9-1-1: Nashville and Under Salt Marsh brought fresh cases to follow.",
    "2026-02": "February leaned toward new arrivals, with drama, crime and comedy running through a schedule shaped by Netflix, CBS and Peacock. Channel 4’s three-part Dirty Business led the month at 9, while Netflix newcomers Lead Children and The Art of Sarah added to the fresh-start feel. Returning favorites like Paradise and Elsbeth kept the month grounded.",
    "2026-03": "March balanced fresh starts with returning favorites, led by Netflix’s strong run across drama, mystery, and crime. JoJo's Bizarre Adventure S6 topped the month at 8.5, while new Hulu drama In Your Radiant Season reached 8.1. Netflix newcomers Boyfriend on Demand and Detective Hole added to a schedule where debuts and established shows both had room to land.",
    "2026-04": "April leaned toward new arrivals, with drama, comedy, and crime filling a schedule led by Netflix, Prime Video, and Hulu. Prime Video’s Nippon Sangoku: The Three Nations of the Crimson Sun topped the month at 8.4, while Netflix’s We Are All Trying Here and Disney+ newcomer Perfect Crown helped make fresh starts the main event. Returning hits like New Bandits and Euphoria kept pace.",
    "2026-05": "May leaned on new arrivals across drama, comedy, and crime, with Prime Video’s Spider-Noir and Off Campus among the month’s strongest debuts. Sky Open’s Bust Up also made a sharp entrance, while Hulu’s Rick and Morty returned at the top of the ratings. Netflix had a notably strong presence, rounding out a month where fresh starts led the way.",
    "2026-06": "June leaned toward new arrivals, with drama, comedy, and crime shaping a schedule that ranged from Netflix’s Agent Kim Reactivated to Crunchyroll Premium’s From Overshadowed to Overpowered: Second Reincarnation of a Talentless Sage. That newcomer led the month at 8.8, while The Bear’s fifth season and House of the Dragon’s return gave Hulu and HBO Max strong familiar draws.",
    "2026-07": "July’s schedule was driven by new arrivals, with animation leading a mix shaped by Crunchyroll Premium, Tokyo MX, and Netflix. Crunchyroll brought a strong run of debuts, including BanG Dream! YumeMita, Crowned in a Hundred Days, and Jaadugar: A Witch in Mongolia. Returning animated favorites also landed well: Netflix’s Avatar: The Last Airbender led the month at 9.3, with X-Men ’97 close behind.",
    "2026-08": "August put new arrivals in the lead, with drama, comedy, and mystery spread across Netflix, Hulu, and AppleTV+. Netflix’s Four Hands, Two Sonatas topped the month at 9, while returning favorites Ted Lasso and Futurama kept the schedule anchored with strong new seasons. Fresh starts drove the month, but familiar shows still had plenty to offer.",
    "2026-09": "September’s new arrivals had more room than usual, with drama, crime, and mystery shaping a schedule led by Netflix, Paramount Plus, and Hulu. But returning shows supplied the month’s biggest draws: South Park topped the ratings at 8.7, followed by The Simpsons, while Paramount Plus also brought back MobLand and Colin from Accounts. Newcomers Neagley and Habeas Corpus made a solid showing.",
    "2026-10": "October’s busy schedule leaned toward new arrivals, with drama, comedy, and crime alongside a strong anime run from Crunchyroll Premium and Tokyo MX. The Apothecary Diaries led the newcomers at 8.6, while Netflix brought Black Clover and Ranma ½; returning favorite Dexter: Resurrection topped the month at 9."
  },
  "bestOf": {
    "2025-07": "It's Always Sunny in Philadelphia takes the top spot in July, with Acapulco at two and The Sandman at three giving the opening a sharp change of pace. Drama runs through most of the list, from Foundation and Karen Pirie to the new crime series Ballard and Untamed, while eight returning shows give the month a familiar core.",
    "2025-08": "Peacemaker takes August’s top spot, with Wednesday at two and Fisk at three opening on a mix of action, supernatural mystery, and comedy. Seven returning shows give the month a familiar core, while Bon Appétit, Your Majesty and Alien: Earth bring new drama with very different genre flavors.",
    "2025-09": "Bob's Burgers takes September’s top spot, with The Morning Show at two and Only Murders in the Building at three giving the opening a mix of comedy and drama. Drama runs through nine of the ten shows, while returning favorites outnumber newcomers and Netflix and Prime Video each appear twice.",
    "2025-10": "One Punch Man leads October’s final top ten, with My Hero Academia and SPY x FAMILY close behind for an anime-heavy opening. Comedy and drama each appear across six shows, but the mix stretches from Mayor of Kingstown’s crime thriller to IT: Welcome to Derry’s horror, with eight returning series giving the month a familiar core.",
    "2025-11": "The Family Man leads November, with Delhi Crime at two and Shetland at four keeping crime close to the top. Six returning shows give the month a familiar feel, while new arrivals The Mighty Nein and Pluribus bring animation and science fiction into a list otherwise led by drama and crime.",
    "2025-12": "Fallout takes the top spot in December, with Ghost Stories for Christmas at two bringing horror and fantasy into a drama-heavy top ten. Five returning shows share the list with five newcomers, while Netflix accounts for half of it, from Pro Bono to The Price of Confession.",
    "2026-01": "The Pitt leads January, with Call the Midwife at two and A Knight of the Seven Kingdoms at three setting a strong opening run. All ten shows are dramas, but fantasy, comedy, crime and mystery keep the month from settling into one mood. Seven returning series give the final ranking a familiar backbone.",
    "2026-02": "Dirty Business takes the top spot in February, with Ghosts at two bringing comedy and fantasy into a list otherwise steeped in drama and crime. Netflix has four of the ten, including new arrivals Lead Children and The Art of Sarah, while returning seasons of Paradise and Kohrra add a strong crime-thriller thread.",
    "2026-03": "JoJo's Bizarre Adventure leads March’s final ranking, with In Your Radiant Season and Eva Lasting rounding out the top three. Drama runs through nine of the ten shows, while mystery and crime keep surfacing in Detective Hole, Beastars and Mystery Road: Origin; seven entries are on Netflix.",
    "2026-04": "Star Wars: Maul - Shadow Lord leads April, with The Boys at two and We Are All Trying Here at three setting up a mix of returning favorites and new arrivals. Drama appears across eight shows, but action and crime keep the list moving, from Nippon Sangoku to Bloodhounds.",
    "2026-06": "From Overshadowed to Overpowered: Second Reincarnation of a Talentless Sage takes June’s top spot, with The Doomies at two and The Bear at three setting an animated, comedic opening before drama takes over. Six returning shows give the month a familiar core, while Crunchyroll Premium appears twice.",
    "2026-07": "Avatar: The Last Airbender leads July, with X-Men '97 right behind it for an animated opening that sets the tone. Crunchyroll Premium accounts for eight of the ten, as new anime such as BanG Dream! YumeMita and You and I Are Polar Opposites sit alongside returning favorites.",
    "2026-05": "Rick and Morty leads May’s final top ten, with Bust Up and Dutton Ranch close behind for a striking mix of crime thriller and Western drama. Drama runs through nine titles, while returning favorites like Good Omens and Rivals share the list with seven new shows, including Off Campus and Spider-Noir.",
    "2026-08": "Four Hands, Two Sonatas takes the top spot in August, with Ted Lasso at two and Futurama at three giving returning favorites an early run. Drama leads the mix, but comedy keeps surfacing, from 1670 and Tires to the romantic comedy Our Sticky Love, while Netflix accounts for six of the ten shows.",
    "2026-09": "South Park takes the top spot in September, with The Simpsons close behind at two, giving the month a strong animated-comedy opening. Then Slow Horses and MobLand lead a crime-heavy stretch, while eight returning shows make this a month shaped more by familiar series than new arrivals.",
    "2026-10": "Love in Disguise takes October’s top spot, with Dragon Ball Super: Beerus at two and Dexter: Resurrection at three opening on a lively mix of crime, action and animation. Eight new shows shape the month, while Crunchyroll Premium supplies half the list, from The Apothecary Diaries to Psyren.",
    "2026-11": "The Chosen is currently at the top of November’s list, with Ethos and Shetland close behind for a drama-heavy opening. All ten picks are returning shows, and the mix ranges from crime and mystery in Blue Lights to comedy in Rivals and St. Denis Medical."
  },
  "bestOfGeneration": {
    "2025-10": {
      "fingerprint": "70bc3752d45d5886ff0eae75b34fad250c286923b9869f85192f66600543d07b",
      "generatedAt": "2026-10-23T10:10:26.676Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "one-punch-man-2015",
        "my-hero-academia-2016",
        "spy-x-family-2022",
        "mayor-of-kingstown-2021",
        "solar-opposites-2020",
        "it-welcome-to-derry-2025",
        "the-witcher-2019",
        "boots-2025",
        "astrid-et-rapha-lle-2019",
        "hazbin-hotel-2019"
      ]
    },
    "2025-11": {
      "fingerprint": "1ebd250b1664223bf8280e1779df703d77556c99af025aac13893fccd8340607",
      "generatedAt": "2026-10-08T02:26:53.015Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "the-family-man-2019",
        "delhi-crime-2019",
        "the-mighty-nein-2025",
        "shetland-2013",
        "landman-2024",
        "power-book-iv-force-2022",
        "pluribus-2025",
        "changing-ends-2023",
        "the-manipulated-2025",
        "as-you-stood-by-2025"
      ]
    },
    "2026-01": {
      "fingerprint": "e466d3748f52d51cb47983e5aab9ac8f1f784867088ff349b60671287da90edb",
      "generatedAt": "2026-10-08T02:26:57.843Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "the-pitt-2025",
        "call-the-midwife-2012",
        "a-knight-of-the-seven-kingdoms-2026",
        "love-through-a-prism-2026",
        "shrinking-2023",
        "gangs-of-london-2020",
        "drops-of-god-2023",
        "corriedale-2026",
        "9-1-1-2018",
        "death-in-paradise-2011"
      ]
    },
    "2026-02": {
      "fingerprint": "4f491a9a7ca6001bc6869a2007c86fadd70d9c14a843de01202600c6e67dae9a",
      "generatedAt": "2026-10-08T02:26:59.821Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "dirty-business-2026",
        "ghosts-2025",
        "paradise-2025",
        "lead-children-2026",
        "kohrra-2023",
        "matlock-2024",
        "the-art-of-sarah-2026",
        "cassandre-2015",
        "museum-of-innocence-2026",
        "the-lady-2026"
      ]
    },
    "2026-03": {
      "fingerprint": "1f993958b0a1e9c2e4a47d41dfcf5da51508869a3314457a45c3f2ff5e6a482f",
      "generatedAt": "2026-10-19T04:04:19.630Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "jojo-s-bizarre-adventure-2012",
        "in-your-radiant-season-2026",
        "eva-lasting-2023",
        "heartbreak-high-2022",
        "detective-hole-2026",
        "boyfriend-on-demand-2026",
        "beastars-2019",
        "girl-from-nowhere-2018",
        "mystery-road-origin-2022",
        "grace-2021"
      ]
    },
    "2026-04": {
      "fingerprint": "671eb804ef58a646fc345df5295d33a4eae83d2ffb65bc306f536a18ac903840",
      "generatedAt": "2026-10-19T04:04:21.791Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "star-wars-maul-shadow-lord-2026",
        "the-boys-2019",
        "we-are-all-trying-here-2026",
        "nippon-sangoku-the-three-nations-of-the-crimson-sun-2026",
        "hacks-2021",
        "new-bandits-2023",
        "the-testaments-2026",
        "euphoria-2019",
        "bloodhounds-2023",
        "perfect-crown-2026"
      ]
    },
    "2026-06": {
      "fingerprint": "301d0e2335760b5b2828cb1cfa514f61436a042ed021bc4ca3669bfa00eeb15b",
      "generatedAt": "2026-10-08T02:27:09.083Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "from-overshadowed-to-overpowered-second-reincarnation-of-a-talentless-sage-2026",
        "the-doomies-2026",
        "the-bear-2022",
        "the-legend-of-vox-machina-2022",
        "house-of-the-dragon-2022",
        "agent-kim-reactivated-2026",
        "the-capture-2019",
        "grantchester-2014",
        "heroine-saint-no-i-m-an-all-works-maid-and-proud-of-it-2026",
        "power-book-iii-raising-kanan-2021"
      ]
    },
    "2026-07": {
      "fingerprint": "3b0058a47ddadc95cf8ed13f6d3f798bf8dfb26a075ebba6dde48d15a571ac4b",
      "generatedAt": "2026-10-08T02:27:10.994Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "avatar-the-last-airbender-2005",
        "x-men-97-2024",
        "bang-dream-yumemita-2026",
        "crowned-in-a-hundred-days-2026",
        "jaadugar-a-witch-in-mongolia-2026",
        "smoking-behind-the-supermarket-with-you-2026",
        "you-and-i-are-polar-opposites-2026",
        "grow-up-show-sunflower-circus-2026",
        "mushoku-tensei-jobless-reincarnation-2021",
        "love-unseen-beneath-the-clear-night-sky-2026"
      ]
    },
    "2025-12": {
      "fingerprint": "7f5be4a69fcc410b35884bbe5bcc3dbf47b4c6398a525e8b650cf604f685b162",
      "generatedAt": "2026-10-08T02:26:55.713Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "fallout-2024",
        "ghost-stories-for-christmas-1971",
        "pro-bono-2025",
        "home-for-christmas-2019",
        "the-price-of-confession-2025",
        "idol-i-2025",
        "surely-tomorrow-2025",
        "the-copenhagen-test-2025",
        "blood-coast-2023",
        "percy-jackson-and-the-olympians-2023"
      ]
    },
    "2026-05": {
      "fingerprint": "5cafb5bcb18678f992ec702efe110deb08cd70d63929a16126ac05c2f7b3e500",
      "generatedAt": "2026-10-19T04:04:23.594Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "rick-and-morty-2013",
        "bust-up-2026",
        "dutton-ranch-2026",
        "song-of-the-samurai-2026",
        "good-omens-2019",
        "vengeance-murder-on-the-heath-2026",
        "off-campus-2026",
        "perfect-match-2025",
        "rivals-2024",
        "spider-noir-2026"
      ]
    },
    "2026-08": {
      "fingerprint": "3f2f818eaeb4b824531e570af700f25f0ad7471ec5c4c13c7f8def4c6d9cc093",
      "generatedAt": "2026-10-08T02:27:12.882Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "four-hands-two-sonatas-2026",
        "ted-lasso-2020",
        "futurama-1999",
        "one-hundred-years-of-solitude-2024",
        "lanterns-2026",
        "reacher-2022",
        "operation-safed-sagar-2026",
        "1670-2023",
        "tires-2024",
        "our-sticky-love-2026"
      ]
    },
    "2026-09": {
      "fingerprint": "ed6260765151120bb9ad8495beff17538df2a33d3135037366fc1c65e0aa969c",
      "generatedAt": "2026-10-08T02:27:14.712Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "south-park-1997",
        "the-simpsons-1989",
        "slow-horses-2022",
        "mobland-2025",
        "colin-from-accounts-2022",
        "outlander-blood-of-my-blood-2025",
        "the-gentlemen-2024",
        "neagley-2026",
        "habeas-corpus-2026",
        "american-horror-story-2011"
      ]
    },
    "2026-10": {
      "fingerprint": "d708c84551639315d4d8b3fff4d4a7956f9356c1a8a4b42cf5dc1ed06ba95b05",
      "generatedAt": "2026-11-01T12:21:05.978Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "love-in-disguise-2026",
        "dragon-ball-super-beerus-2026",
        "dexter-resurrection-2025",
        "take-charge-of-my-heart-2026",
        "the-apothecary-diaries-2023",
        "100-days-of-deception-2026",
        "doumo-sukina-hito-hi-horegusuri-o-irai-sareta-majo-desu-2026",
        "psyren-3275927",
        "a-tale-of-the-secret-saint-2026",
        "the-laid-off-cheat-granting-mage-enjoys-a-second-lease-on-life-2026"
      ]
    },
    "2025-07": {
      "fingerprint": "9258e60bc1bccd2c84769bc58461a3d9cc87eb0b55f8a8341889265dab0b467c",
      "generatedAt": "2026-10-31T11:09:48.058Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "it-s-always-sunny-in-philadelphia-2005",
        "acapulco-2021",
        "the-sandman-2022",
        "foundation-2021",
        "karen-pirie-2022",
        "ballard-2025",
        "such-brave-girls-2023",
        "the-summer-i-turned-pretty-2022",
        "twisted-metal-2023",
        "untamed-2025"
      ]
    },
    "2025-08": {
      "fingerprint": "df7a090c793219b2d5875e3d6cff4694088a7a169b0b7954ef58af3678629504",
      "generatedAt": "2026-10-22T10:15:49.926Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "peacemaker-2022",
        "wednesday-2022",
        "fisk-2021",
        "bon-app-tit-your-majesty-2025",
        "upload-2020",
        "the-terminal-list-dark-wolf-2025",
        "professor-t-2021",
        "platonic-2023",
        "the-marlow-murder-club-2024",
        "alien-earth-2025"
      ]
    },
    "2025-09": {
      "fingerprint": "2c285e5f7b750a6f05fcdb8edf576029b7db1173913e15f8b941b50c29ca7cd6",
      "generatedAt": "2026-10-19T04:04:15.104Z",
      "model": "gpt-6-luna",
      "ratingMode": "snapshot",
      "ranking": [
        "bob-s-burgers-2011",
        "the-morning-show-2019",
        "only-murders-in-the-building-2021",
        "the-runarounds-2025",
        "you-and-everything-else-2025",
        "human-2022",
        "the-ba-ds-of-bollywood-2025",
        "gen-v-2023",
        "the-walking-dead-daryl-dixon-2023",
        "sygeplejeskolen-2018"
      ]
    },
    "2026-11": {
      "fingerprint": "44c46787bfc689ea070f5fbd77ef3a66418cec5be2aa7f3651a0a181bc781c9e",
      "generatedAt": "2026-11-01T12:21:07.314Z",
      "model": "gpt-6-luna",
      "ratingMode": "current",
      "ranking": [
        "the-chosen-2017",
        "ethos-2020",
        "shetland-2013",
        "blue-lights-2023",
        "the-gilded-age-2022",
        "rivals-2024",
        "yellowjackets-2021",
        "miraculous-les-aventures-de-ladybug-et-chat-noir-2015",
        "city-of-god-the-fight-rages-on-2024",
        "st-denis-medical-2024"
      ]
    }
  }
}